import React from 'react';

import { MAX_WORD_EXPORT_IMAGES } from '../../../features/template-workspace/word-export/model/wordExport';

/**
 * Блок для отображения и управления снимками (изображениями) пациента.
 * Позволяет добавлять, удалять и подписывать снимки.
 *
 * Пропсы:
 *  - images: массив объектов изображений (id, url, width, height, caption)
 *  - setImages: функция для обновления массива изображений
 */
const PicturesBlock = ({ images, setImages }) => (
  <div className="template-block" style={{ paddingLeft: 10, marginTop: 0 }}>
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, alignItems: 'flex-start' }}>
      {images.slice(0, MAX_WORD_EXPORT_IMAGES).map((img, idx) => (
        <div key={img.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 180 }}>
          <img
            src={img.url}
            alt={`Снимок ${idx + 1}`}
            style={{ width: 180, height: 180, objectFit: 'cover', borderRadius: 8, border: '1px solid #ccc', background: '#f8f8f8' }}
          />
          <input
            type="text"
            value={img.caption}
            onChange={e => {
              setImages(prev => prev.map((im, i) => i === idx ? { ...im, caption: e.target.value } : im));
            }}
            placeholder={`Текст ${idx+1}`}
            style={{
              width: 180,
              fontSize: 15,
              padding: '8px',
              borderRadius: 8,
              border: '1px solid #ccd1d9',
              background: '#f4f6f8',
              color: '#2c3e50',
              boxSizing: 'border-box',
              textAlign: 'center',
              outline: 'none',
              marginTop: 8
            }}
          />
          <button
            style={{ marginTop: 8, background: '#dc3545', color: 'white', border: 'none', borderRadius: 4, padding: '4px 12px', cursor: 'pointer', fontSize: 15 }}
            onClick={() => {
              setImages(prev => prev.filter((_, i) => i !== idx));
            }}
          >
            Удалить
          </button>
        </div>
      ))}
      {images.length < MAX_WORD_EXPORT_IMAGES ? (
        <label
          style={{
            width: 180, height: 180, border: '2px dashed #ccc', borderRadius: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexDirection: 'column', background: '#fafbfc', color: '#aaa', fontSize: 48
          }}
          title="Добавить снимок"
        >
          <span>+</span>
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={e => {
              const file = e.target.files[0];
              if (file) {
                const reader = new FileReader();
                reader.onload = ev => {
                  const url = ev.target.result;
                  const img = new window.Image();
                  img.onload = () => {
                    setImages(prev => {
                      if (prev.length >= MAX_WORD_EXPORT_IMAGES) {
                        return prev;
                      }

                      return [...prev, {
                        id: Date.now() + Math.random(),
                        file,
                        url,
                        width: img.width,
                        height: img.height,
                        caption: ''
                      }];
                    });
                  };
                  img.src = url;
                };
                reader.readAsDataURL(file);
              }
            }}
          />
        </label>
      ) : (
        <div
          style={{
            width: 180,
            minHeight: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6c757d',
            fontSize: 13,
            textAlign: 'center',
          }}
        >
          Можно добавить не более {MAX_WORD_EXPORT_IMAGES} снимков
        </div>
      )}
    </div>
  </div>
);

export default PicturesBlock;
